export {CoachRankMonthBoxConnected as CoachRankMonthBox} from './CoachRankMonthBox';
